
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/currency-rate",
      function () {
        return require("private-next-pages/currency-rate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/currency-rate"])
      });
    }
  